import Page00 from '../../../../Book/EbookRecrutement/Pages/00';
import Page01 from '../../../../Book/EbookRecrutement/Pages/01';
import Page02 from '../../../../Book/EbookRecrutement/Pages/02';
import Page03 from '../../../../Book/EbookRecrutement/Pages/03';
import Page04 from '../../../../Book/EbookRecrutement/Pages/04';
import Page05 from '../../../../Book/EbookRecrutement/Pages/05';
import Page06 from '../../../../Book/EbookRecrutement/Pages/06';
import Page07 from '../../../../Book/EbookRecrutement/Pages/07';
import Page08 from '../../../../Book/EbookRecrutement/Pages/08';
import Page09 from '../../../../Book/EbookRecrutement/Pages/09';
import Page10 from '../../../../Book/EbookRecrutement/Pages/10';
import Page11 from '../../../../Book/EbookRecrutement/Pages/11';
import Page12 from '../../../../Book/EbookRecrutement/Pages/12';
import Page13 from '../../../../Book/EbookRecrutement/Pages/13';
import Page14 from '../../../../Book/EbookRecrutement/Pages/14';
import Page15 from '../../../../Book/EbookRecrutement/Pages/15';
import Page16 from '../../../../Book/EbookRecrutement/Pages/16';
import Page17 from '../../../../Book/EbookRecrutement/Pages/17';
import Page18 from '../../../../Book/EbookRecrutement/Pages/18';
import Page19 from '../../../../Book/EbookRecrutement/Pages/19';
import Page20 from '../../../../Book/EbookRecrutement/Pages/20';
import Page21 from '../../../../Book/EbookRecrutement/Pages/21';
import Page22 from '../../../../Book/EbookRecrutement/Pages/22';
import Page23 from '../../../../Book/EbookRecrutement/Pages/23';
import Page24 from '../../../../Book/EbookRecrutement/Pages/24';
import Page25 from '../../../../Book/EbookRecrutement/Pages/25';
import Page26 from '../../../../Book/EbookRecrutement/Pages/26';
import Page27 from '../../../../Book/EbookRecrutement/Pages/27';
import Page28 from '../../../../Book/EbookRecrutement/Pages/28';
import Page29 from '../../../../Book/EbookRecrutement/Pages/29';
import Page30 from '../../../../Book/EbookRecrutement/Pages/30';
import Page31 from '../../../../Book/EbookRecrutement/Pages/31';
import Page32 from '../../../../Book/EbookRecrutement/Pages/32';
import Page33 from '../../../../Book/EbookRecrutement/Pages/33';
import Page34 from '../../../../Book/EbookRecrutement/Pages/34';
import Page35 from '../../../../Book/EbookRecrutement/Pages/35';
import Page36 from '../../../../Book/EbookRecrutement/Pages/36';
import Page37 from '../../../../Book/EbookRecrutement/Pages/37';
import Page38 from '../../../../Book/EbookRecrutement/Pages/38';
import Page39 from '../../../../Book/EbookRecrutement/Pages/39';
import Page40 from '../../../../Book/EbookRecrutement/Pages/40';
import Page41 from '../../../../Book/EbookRecrutement/Pages/41';
import Page42 from '../../../../Book/EbookRecrutement/Pages/42';
import Page43 from '../../../../Book/EbookRecrutement/Pages/43';
import Page44 from '../../../../Book/EbookRecrutement/Pages/44';
import Page45 from '../../../../Book/EbookRecrutement/Pages/45';
import Page46 from '../../../../Book/EbookRecrutement/Pages/46';
import Page47 from '../../../../Book/EbookRecrutement/Pages/47';
import Page48 from '../../../../Book/EbookRecrutement/Pages/48';
import Page49 from '../../../../Book/EbookRecrutement/Pages/49';
import Page50 from '../../../../Book/EbookRecrutement/Pages/50';
import Page51 from '../../../../Book/EbookRecrutement/Pages/51';
import Page52 from '../../../../Book/EbookRecrutement/Pages/52';
import Page53 from '../../../../Book/EbookRecrutement/Pages/53';
import Page54 from '../../../../Book/EbookRecrutement/Pages/54';
import Page55 from '../../../../Book/EbookRecrutement/Pages/55';
import Page56 from '../../../../Book/EbookRecrutement/Pages/56';
import Page57 from '../../../../Book/EbookRecrutement/Pages/57';

type RecrutementContentProps = {
  id?: string;
  readOnly: boolean;
};

const RecrutementContent = ({ id, readOnly }: RecrutementContentProps) => (
  <>
    <Page00 />
    <Page01 />
    <Page02 />
    <Page03 />
    <Page04 />
    <Page05 />
    <Page06 />
    <Page07 />
    <Page08 />
    <Page09 idEbook={id} readOnly={readOnly} />
    <Page10 />
    <Page11 />
    <Page12 />
    <Page13 />
    <Page14 idEbook={id} readOnly={readOnly} />
    <Page15 />
    <Page16 />
    <Page17 />
    <Page18 />
    <Page19 />
    <Page20 />
    <Page21 idEbook={id} readOnly={readOnly} />
    <Page22 />
    <Page23 idEbook={id} readOnly={readOnly} />
    <Page24 />
    <Page25 idEbook={id} readOnly={readOnly} />
    <Page26 idEbook={id} readOnly={readOnly} />
    <Page27 idEbook={id} readOnly={readOnly} />
    <Page28 idEbook={id} readOnly={readOnly} />
    <Page29 idEbook={id} readOnly={readOnly} />
    <Page30 />
    <Page31 />
    <Page32 />
    <Page33 />
    <Page34 idEbook={id} readOnly={readOnly} />
    <Page35 idEbook={id} readOnly={readOnly} />
    <Page36 />
    <Page37 />
    <Page38 />
    <Page39 idEbook={id} readOnly={readOnly} />
    <Page40 />
    <Page41 />
    <Page42 />
    <Page43 />
    <Page44 />
    <Page45 idEbook={id} readOnly={readOnly} />
    <Page46 idEbook={id} readOnly={readOnly} />
    <Page47 idEbook={Number(id)} readOnly={readOnly} />
    <Page48 idEbook={Number(id)} readOnly={readOnly} />
    <Page49 />
    <Page50 />
    <Page51 idEbook={id} readOnly={readOnly} />
    <Page52 idEbook={id} readOnly={readOnly} />
    <Page53 />
    <Page54 idEbook={id} readOnly={readOnly} />
    <Page55 />
    <Page56 />
    <Page57 />
  </>
);

export default RecrutementContent;
